var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5668 0.321129C12.0882 -0.10787 11.3141 -0.10787 10.8367 0.321129L0.716748 9.41153C0.490218 9.61191 0.30984 9.85308 0.186583 10.1204C0.0633268 10.3877 -0.000233687 10.6755 -0.000233661 10.9664C-0.000233636 11.2573 0.0633269 11.5451 0.186584 11.8124C0.30984 12.0797 0.490218 12.3209 0.716748 12.5212L10.9099 21.6787C11.1413 21.8834 11.4476 21.9984 11.7668 22.0005C12.0859 22.0025 12.394 21.8914 12.6283 21.6897C12.7444 21.5901 12.8373 21.4694 12.9012 21.3351C12.9651 21.2007 12.9987 21.0555 13 20.9086C13.0012 20.7617 12.97 20.616 12.9083 20.4808C12.8466 20.3455 12.7557 20.2235 12.6413 20.1222L3.31202 11.7435C3.19866 11.6433 3.1084 11.5227 3.04671 11.389C2.98503 11.2553 2.95322 11.1113 2.95322 10.9658C2.95322 10.8203 2.98503 10.6763 3.04671 10.5426C3.1084 10.4089 3.19866 10.2883 3.31202 10.1881L12.5668 1.87543C12.6802 1.77533 12.7704 1.65481 12.8321 1.5212C12.8937 1.38759 12.9256 1.2437 12.9256 1.09828C12.9256 0.952866 12.8937 0.80897 12.8321 0.675362C12.7704 0.541754 12.6802 0.42123 12.5668 0.321129Z",
    fill: "#FFCA2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.90543eedcadc3483915ff2eb0c34f7da.svg";
export { ForwardRef as ReactComponent };